/* eslint-disable no-async-promise-executor */
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

fetch('/config')
  .then((response) => response.json())
  .then(async (config) => {
    ((g) => {
      const p = 'The Google Maps JavaScript API',
        c = 'google',
        l = 'importLibrary',
        q = '__ib__',
        m = document;
      let h: any,
        a,
        k,
        b: any = window;
      b = b[c] || (b[c] = {});
      const d = b.maps || (b.maps = {}),
        r = new Set(),
        e = new URLSearchParams(),
        u = (): any =>
          h ||
          (h = new Promise(async (f, n) => {
            await (a = m.createElement('script'));
            e.set('libraries', [...r] + '');
            for (k in g)
              e.set(
                k.replace(/[A-Z]/g, (t) => '_' + t[0].toLowerCase()),
                (g as any)[k]
              );
            e.set('callback', c + '.maps.' + q);
            a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
            d[q] = f;
            a.onerror = () => (h = n(Error(p + ' could not load.')));
            a.nonce = (m.querySelector('script[nonce]') as any)?.nonce || '';
            m.head.append(a);
          }));
      d[l]
        ? console.warn(p + ' only loads once. Ignoring:', g)
        : (d[l] = (f: unknown, ...n: any) => r.add(f) && u().then(() => d[l](f, ...n)));
    })({ key: config.mapsApiKey, v: 'weekly' });

    await google.maps.importLibrary('maps');
    await google.maps.importLibrary('marker');

    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
  });
